import common from 'constants/common';
import { SUCCESS_MESSAGE, successMessages } from 'constants/messages';
import { notificationController } from 'infrastructure/antd/controllers/notification-controller';

const hiddenErrors = ['patient not exists', "patient's thresholds not exists"];

const normalizeError = (error: any): string => {
  if (!error) return '';
  if (typeof error === 'string') return error;
  if (error?.message) return error.message;
  return String(error);
};

export const showResult = (
  error?: any,
  type?: keyof typeof common.submitSuccessTypes | null,
  successCallback?: () => void,
  callback?: () => void,
) => {
  const errorMessage = normalizeError(error);

  if (errorMessage && hiddenErrors.includes(errorMessage)) {
    return;
  }

  if (errorMessage && errorMessage.startsWith('Warning:')) {
    notificationController.warning({ message: errorMessage });
    return;
  }

  if (errorMessage) {
    const text = errorMessage.startsWith('Error:')
      ? errorMessage
      : `Error: ${
          errorMessage.charAt(0).toUpperCase() + errorMessage.slice(1)
        }`;

    switch (errorMessage) {
      case 'Failed to fetch':
        notificationController.error({ message: `Connection error` });
        break;
      default:
        notificationController.error({ message: text });
        break;
    }
  } else {
    switch (type) {
      case common.submitSuccessTypes.changed:
        notificationController.success({
          message: successMessages.changes,
        });
        break;
      case common.submitSuccessTypes.reviewed:
        notificationController.success({ message: successMessages.reviewed });
        break;
      case common.submitSuccessTypes.bulkReviewed:
        notificationController.success({
          message: successMessages.bulkReviewed,
        });
        break;
      case common.submitSuccessTypes.sendReport:
        notificationController.success({ message: successMessages.sendReport });
        break;
      case common.submitSuccessTypes.deleted:
        notificationController.success({ message: successMessages.deleted });
        break;
      default:
        notificationController.success({ message: SUCCESS_MESSAGE });
        break;
    }
  }

  if (callback) callback();

  if (successCallback && !errorMessage) {
    successCallback();
  }
};
